
import {Component, Vue, Watch} from "vue-property-decorator";
import {renewalProductKeyForPath, RenewalProductKey} from "@/utils/renewalOffer";

const SESSION_FLAG = 'icw_renewal_modal_shown';

/**
 * 20-8 gün kademesi: login sonrası oturum başına bir kez açılan teklif modalı.
 * Karanlık scrim yerine arka planı hafifçe flulaştırır (overlay-opacity=0 +
 * backdrop-filter). Kapatılabilir; sayfa geçişlerinde tekrar açılmaz, ancak
 * yeni oturumda (sessionStorage temizlenince) yeniden gösterilir.
 */
@Component
export default class RenewalModal extends Vue {
  show = false;
  loading = false;

  // $route.path reaktif: ürün geçişinde anahtar ve teklif otomatik güncellenir.
  get productKey(): RenewalProductKey {
    return renewalProductKeyForPath(this.$route.path);
  }

  // Kullanıcının bulunduğu ürünün teklifi (İcraProWeb / e-İcraPro ayrı).
  get offer() {
    return this.$store.getters.renewalOfferFor(this.productKey);
  }

  // Oturum-başına-bir-kez bayrağı ürün-bazlı: her ürün kendi modalını bir kez gösterir.
  get sessionFlagKey(): string {
    return `${SESSION_FLAG}_${this.productKey}`;
  }

  get daysLeft(): number | null {
    return this.offer?.days_left ?? null;
  }

  get packageName(): string {
    return this.offer?.package_name ?? 'mevcut paketiniz';
  }

  mounted() {
    this.maybeOpen();
  }

  @Watch('offer')
  onOfferChange() {
    this.maybeOpen();
  }

  // Ürün değişince (route) o ürünün modalını değerlendir.
  @Watch('$route')
  onRouteChange() {
    this.maybeOpen();
  }

  maybeOpen() {
    if (!this.offer?.eligible || this.offer.tier !== 'modal') {
      return;
    }
    try {
      if (sessionStorage.getItem(this.sessionFlagKey)) {
        return;
      }
      sessionStorage.setItem(this.sessionFlagKey, '1');
    } catch (e) {
      // sessionStorage erişilemezse bir kez göstermeyi dene, tekrarını engelleyemeyiz.
    }
    this.show = true;
  }

  close() {
    this.show = false;
  }

  async onRenew() {
    this.loading = true;
    try {
      await this.$store.dispatch('startRenewalCheckout', this.productKey);
    } finally {
      this.loading = false;
    }
  }
}
